import { render, staticRenderFns } from "./CMPage.vue?vue&type=template&id=ed9986b4&scoped=true&lang=pug&"
import script from "./CMPage.vue?vue&type=script&lang=js&"
export * from "./CMPage.vue?vue&type=script&lang=js&"
import style0 from "./CMPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CMPage.vue?vue&type=style&index=1&id=ed9986b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9986b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VPagination})
